import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { globalData } from '../../services/globalData.service';

@Injectable()
export class MyProfileInterceptor implements HttpInterceptor {

  constructor(private router: Router, private globalService: globalData) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add common headers to the request
    const modifiedRequest = request.clone({      
      setHeaders: {
        'Authorization': `Bearer ${localStorage.getItem('loginUserToken')}`
      },
    });       
    // Pass the modified request to the next interceptor or to the server
    return next.handle(modifiedRequest).pipe(
      map((event: HttpEvent<any>) => {
        // If the response is an HttpResponse, you can log or process it here
        if (event instanceof HttpResponse) {
          //console.log('Response:', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle errors here
        //console.error('Error:', error);       
        // Re-throw the error to propagate it to the subscriber        
        if(error.status == 401){
          this.globalService.clearCustomerSession();
          this.router.navigate(['/home']);
        }
        return throwError(error);
      })
    );
  }
}